import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "pad15",
  style: {"height":"280px","width":"400px"}
}
const _hoisted_2 = { class: "h20" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = {
  class: "title mc",
  style: {}
}
const _hoisted_6 = {
  class: "fw600 fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_8 = {
  class: "",
  style: {}
}
const _hoisted_9 = {
  key: 0,
  class: "fs14 fw600 mt10"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = {
  key: 1,
  class: "fs14 fw600 mt10"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = {
  key: 2,
  class: "fs14 fw600 mt10"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_15 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}, "作成", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 1,
  class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg disabled",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "fs14 fw400" }, "未入力です", -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "InputAstagNameModal",
    "content-class": "rad10 with_white_bg shadowContent modalSmall noscroll InputLocationModal",
    onBeforeClose: _ctx.fadeOutModal,
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, null, 8, _hoisted_3)
        ]),
        _hoisted_4,
        _createElementVNode("div", {
          class: "ofs centered",
          style: _normalizeStyle({
                    height: `${_ctx.contentHeight}px`,
                    overscrollBehavior: 'contain',
                })
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.getTitle), 1)
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            (_ctx.createType == `normal`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createTextVNode(" どういった調整用の調整カレンダーですか？"),
                  _hoisted_10,
                  _createTextVNode("わかりやすく名前をつけましょう！ ")
                ]))
              : (_ctx.createType == `vote`)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createTextVNode(" カレンダーに登録される会議名を入力してください。"),
                    _hoisted_12
                  ]))
                : (_ctx.createType == `aform`)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createTextVNode(" どういった振り分けで使うフォームですか？"),
                      _hoisted_14,
                      _createTextVNode("わかりやすく名前をつけましょう！ ")
                    ]))
                  : _createCommentVNode("", true),
            _createVNode(_component_MdTextfieldTag, {
              fieldStyle: "min-width:280px;max-width:100%;",
              style: {"height":"56px","min-width":"280px","max-width":"100%"},
              class: "fl fs16",
              type: `AstagName`,
              placeholder: _ctx.createType == `aform` ? `担当者振り分け用` : `ランチミーティング用`,
              value: _ctx.astagName,
              onInputValue: _ctx.inputName,
              onBlur: _ctx.checkName,
              errMessage: _ctx.validName ? null : `入力してください。`,
              ref: `AstagInputField`,
              onEnter: _ctx.enterName,
              required: ""
            }, null, 8, ["placeholder", "value", "onInputValue", "onBlur", "errMessage", "onEnter"])
          ])
        ], 4)
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (_ctx.validName)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                id: "roomCloseButton",
                class: "w100 skyblueBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createAstag && _ctx.createAstag(...args)))
              }, _hoisted_19))
            : (_openBlock(), _createElementBlock("section", _hoisted_20, _hoisted_22))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onBeforeClose", "onBeforeOpen"]))
}